import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Login from '@/views/Login/Login.vue'
import store from '@/store'
import NProgress from "nprogress";

const routes = [
  {
    path:'/upload',
    name : 'upload',
    component: ()=> import('../views/upload.vue'),
  },
  {
    path:'/preview',
    name : 'preview',
    component: ()=> import('../views/preview.vue'),
  },
  {
    path:'/',
    name : '/',
    component : Login,
  },
  {
    path:'/login',
    name : 'login',
    component : Login,
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/Home.vue'),
    children: [
      {
        path: "/Tab1Content",
        name: "Tab1Content",
        component: ()=> import('../views/Tab1/Content/Tab1Content.vue'),
        children: [
          {
            path: "TestingApplication",
            name: "Tab1/TestingApplication",
            component: () => import('../views/Tab1/Content/SampleManage/TestingApplication.vue'),
          },
          {
            path: "SampleInformation",
            name: "Tab1/SampleInformation",
            component: () => import('../views/Tab1/Content/SampleManage/SampleInformation.vue'),
          },
          {
            path: "NewSampleInformation",
            name: "Tab1/NewSampleInformation",
            component: () => import('../views/Tab1/Content/SampleManage/NewSampleInformation.vue'),
          },
          {
            path: "ChangeSampleInformation",
            name: "Tab1/ChangeSampleInformation",
            component: () => import('../views/Tab1/Content/SampleManage/ChangeSampleInformation.vue'),
          },
          {
            path: "ReportPackageRecord",
            name: "Tab1/ReportPackageRecord",
            component: () => import('../views/Tab1/Content/SampleManage/ReportPackageRecord.vue'),
          },
          {
            path: "NewReportPackageRecord",
            name: "Tab1/NewReportPackageRecord",
            component: () => import('../views/Tab1/Content/SampleManage/NewReportPackageRecord.vue'),
          },
          {
            path: "ReturningSamples",
            name: "Tab1/ReturningSamples",
            component: () => import('../views/Tab1/Content/ExpressManage/ReturningSamples.vue'),
          },
          {
            path: "ReturningSamplesRecord",
            name: "Tab1/ReturningSamplesRecord",
            component: () => import('../views/Tab1/Content/ExpressManage/ReturningSamplesRecord.vue'),
          },
          {
            path: "NewReturningSamplesRecord",
            name: "Tab1/NewReturningSamplesRecord",
            component: () => import('../views/Tab1/Content/ExpressManage/NewReturningSamplesRecord.vue'),
          },
          {
            path: "ReturnSampleInfo",
            name: "Tab1/ReturnSampleInfo",
            component: () => import('../views/Tab1/Content/ExpressManage/ReturnSampleInfo.vue'),
          },
          {
            path: "NewReturnSampleInfo",
            name: "Tab1/NewReturnSampleInfo",
            component: () => import('../views/Tab1/Content/ExpressManage/NewReturnSampleInfo.vue'),
          },
          {
            path: "ExpressManagement",
            name: "Tab1/ExpressManagement",
            component: () => import('../views/Tab1/Content/ExpressManage/ExpressManagement.vue'),
          },
          {
            path: "CompoundQuery",
            name: "Tab1/CompoundQuery",
            component: () => import('../views/Tab1/Content/QueryStatistics/CompoundQuery.vue'),
          },
          {
            path: "ReportQuery",
            name: "Tab1/ReportQuery",
            component: () => import('../views/Tab1/Content/QueryStatistics/ReportQuery.vue'),
          },
          {
            path: "SampleBoxApplication",
            name: "Tab1/SampleBoxApplication",
            component: () => import('../views/Tab1/Content/SampleBoxManage/SampleBoxApplication.vue'),
          },
          {
            path: "SampleBoxRecord",
            name: "Tab1/SampleBoxRecord",
            component: () => import('../views/Tab1/Content/SampleBoxManage/SampleBoxRecord.vue'),
          },
          {
            path: "BarcodeDatabase",
            name: "Tab1/BarcodeDatabase",
            component: () => import('../views/Tab1/Content/SampleBoxManage/BarcodeDatabase.vue'),
          },
          {
            path: "BasicInformation",
            name: "Tab1/BasicInformation",
            component: () => import('../views/Tab1/Content/InformationManage/BasicInformation.vue'),
          },
          {
            path: "User",
            name: "Tab1/User",
            component: () => import('../views/Tab1/Content/InformationManage/User.vue'),
          },
          {
            path: "AddUser",
            name: "Tab1/AddUser",
            component: () => import('../views/Tab1/Content/InformationManage/AddUser.vue'),
          },
          {
            path: "RightsManage",
            name: "Tab1/RightsManage",
            component: () => import('../views/Tab1/Content/InformationManage/RightsManage.vue'),
          },
          {
            path: "AddRole",
            name: "Tab1/AddRole",
            component: () => import('../views/Tab1/Content/InformationManage/AddRole.vue'),
          },
          {
            path: "SubmissionDepartment",
            name: "Tab1/SubmissionDepartment",
            component: () => import('../views/Tab1/Content/InformationManage/SubmissionDepartment.vue'),
          },
          {
            path: "AddDepartment",
            name: "Tab1/AddDepartment",
            component: () => import('../views/Tab1/Content/InformationManage/AddDepartment.vue'),
          },
          {
            path: "SubmissionPhysicians",
            name: "Tab1/SubmissionPhysicians",
            component: () => import('../views/Tab1/Content/InformationManage/SubmissionPhysicians.vue'),
          },
          {
            path: "AddPhysician",
            name: "Tab1/AddPhysician",
            component: () => import('../views/Tab1/Content/InformationManage/AddPhysician.vue'),
          },
        ]
      },
      {
        path : "/Tab2Content",
        name : "Tab2Content",
        component : ()=>import('../views/Tab2/Content/Tab2Content.vue'),
        children:[
          {
            // path : "DepartmentInformation",
            path :  "DepartmentInformation",
            name : "DepartmentInformation",
            meta : {
              title : "Tab2.DepartmentInformation",
              roles : ["Admin"],
            },

            component : ()=>import('../views/Tab2/Content/SystemManage/DepartmentInformation.vue'),
          },
          {
            // path: "NewDepartment/:departmentInfo",
            // props: true,
            path: "NewDepartment",
            name : "NewDepartment",
            component : ()=>import('../views/Tab2/Content/SystemManage/NewDepartment.vue'),
          },
          {
            path : "UserManage",
            name : "UserManage",
            component : ()=>import('../views/Tab2/Content/SystemManage/UserManage.vue'),
          },
          {
            path : "NewUser",
            name : "NewUser",
            component : ()=>import('../views/Tab2/Content/SystemManage/NewUser.vue'),
          },
          {
            path : "Roles",
            name : "Roles",
            component : ()=>import('../views/Tab2/Content/SystemManage/Roles.vue'),
          },
          {
            path : "NewRoles",
            name : "NewRoles",
            component : ()=>import('../views/Tab2/Content/SystemManage/NewRoles.vue'),
          },
          {
            path : "TestBase",
            name : "TestBase",
            component : ()=>import('../views/Tab2/Content/SystemManage/TestBase.vue'),
          },
          {
            path : "NewTestBase",
            name : "NewTestBase",
            component : ()=>import('../views/Tab2/Content/SystemManage/NewTestBase.vue'),
          },
          {
            path : "TestProjects",
            name : "TestProjects",
            component : ()=>import('../views/Tab2/Content/DataManage/TestProjects.vue'),
          },
          {
            path : "NewTestProjects",
            name : "NewTestProjects",
            component : ()=>import('../views/Tab2/Content/DataManage/NewTestProjects.vue'),
          },
          {
            path : "ProjectSeries",
            name : "ProjectSeries",
            component : ()=>import('../views/Tab2/Content/DataManage/ProjectSeries.vue'),
          },
          {
            path : "NewProjectSeries",
            name : "NewProjectSeries",
            component : ()=>import('../views/Tab2/Content/DataManage/NewProjectSeries.vue'),
          },
          {
            path : "SampleType",
            name : "SampleType",
            component : ()=>import('../views/Tab2/Content/DataManage/SampleType.vue'),
          },
          {
            path : "NewSampleType",
            name : "NewSampleType",
            component : ()=>import('../views/Tab2/Content/DataManage/NewSampleType.vue'),
          },
          {
            path : "Agent",
            name : "Agent",
            component : ()=>import('../views/Tab2/Content/CustomerManage/Agent.vue'),
          },
          {
            path : "NewAgent",
            name : "NewAgent",
            component : ()=>import('../views/Tab2/Content/CustomerManage/NewAgent.vue'),
          },
          {
            path : "EditAgentUser",
            name : "EditAgentUser",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditAgentUser.vue'),
          },
          {
            path : "EditAgentUserEditUser",
            name : "EditAgentUserEditUser",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditAgentUserEditUser.vue'),
          },
          {
            path : "EditAgentRole",
            name : "EditAgentRole",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditAgentRole.vue'),
          },
          {
            path : "EditAgentRoleEditRole",
            name : "EditAgentRoleEditRole",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditAgentRoleEditRole.vue'),
          },
          {
            path : "Hospital",
            name : "Hospital",
            component : ()=>import('../views/Tab2/Content/CustomerManage/Hospital.vue'),
          },
          {
            path : "NewHospital",
            name : "NewHospital",
            component : ()=>import('../views/Tab2/Content/CustomerManage/NewHospital.vue'),
          },
          {
            path : "EditHospitalUser",
            name : "EditHospitalUser",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditHospitalUser.vue'),
          },
          {
            path : "EditHospitalUserEditUser",
            name : "EditHospitalUserEditUser",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditHospitalUserEditUser.vue'),
          },
          {
            path : "EditHospitalRole",
            name : "EditHospitalRole",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditHospitalRole.vue'),
          },
          {
            path : "EditHospitalRoleEditRole",
            name : "EditHospitalRoleEditRole",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditHospitalRoleEditRole.vue'),
          },
          {
            path : "EditCheckProject",
            name : "EditCheckProject",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditCheckProject.vue'),
          },
          {
            path : "EditCheckProjectAddProject",
            name : "EditCheckProjectAddProject",
            component : ()=>import('../views/Tab2/Content/CustomerManage/EditCheckProjectAddProject.vue'),
          },
          {
            path : "SampleBoxApplicationInfo",
            name : "SampleBoxApplicationInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/SampleBoxApplicationInfo.vue'),
          },
          {
            path : "NewSampleBoxApplicationInfo",
            name : "NewSampleBoxApplicationInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/NewSampleBoxApplicationInfo.vue'),
          },
          {
            path : "BarcodeLibrary",
            name : "BarcodeLibrary",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/BarcodeLibrary.vue'),
          },
          {
            path : "NewBarcodeLibrary",
            name : "NewBarcodeLibrary",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/NewBarcodeLibrary.vue'),
          },
          {
            path: "ReportPackageInfo",
            name: "ReportPackageInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/ReportPackageInfo.vue'),
          },
          {
            path: "NewReportPackageInfo",
            name: "NewReportPackageInfo",
            component: ()=>import('../views/Tab2/Content/BusinessSystem/NewReportPackageInfo.vue'),
          },
          {
            path : "ReturnBagInfo",
            name : "ReturnBagInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/ReturnBagInfo.vue'),
          },
          {
            path : "NewReturnBagInfo",
            name : "NewReturnBagInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/NewReturnBagInfo.vue'),
          },
          {
            path : "ReturnSample",
            name : "ReturnSample",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/ReturnSample/ReturnSample.vue'),
          },
          {
            path : "ReturnSampleInfo",
            name : "ReturnSampleInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/ReturnSample/ReturnSampleInfo.vue'),
          },
          {
            path : "NewReturnSampleInfo",
            name : "NewReturnSampleInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/ReturnSample/NewReturnSampleInfo.vue'),
          },
          {
            path : "SubjectSampleInfo",
            name : "SubjectSampleInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/SubjectSampleInfo.vue'),
          },
          {
            path : "NewSubjectSampleInfo",
            name : "NewSubjectSampleInfo",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/NewSubjectSampleInfo.vue'),
          },
          {
            path : "SampleHandoverForm",
            name : "SampleHandoverForm",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/SampleHandoverForm.vue'),
          },
          {
            path : "Reports",
            name : "Reports",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/Reports.vue'),
            children: [
              {
                path:"GeneticDataImport",
                name:"GeneticDataImport",
                component:()=>import('../views/Tab2/Content/BusinessSystem/Reports/GeneticDataImport.vue')
              },
              {
                path:"SampleDataImport",
                name:"SampleDataImport",
                component:()=>import('../views/Tab2/Content/BusinessSystem/Reports/SampleDataImport.vue')
              },
              {
                path:"ReportFileUpload",
                name:"ReportFileUpload",
                component:()=>import('../views/Tab2/Content/BusinessSystem/Reports/ReportFileUpload.vue')
              },
              {
                path:"ScanCodeImport",
                name:"ScanCodeImport",
                component:()=>import('../views/Tab2/Content/BusinessSystem/Reports/ScanCodeImport.vue')
              },

            ]
          },
          {
            path : "QueryStatistics",
            name : "QueryStatistics",
            component : ()=>import('../views/Tab2/Content/BusinessSystem/QueryStatistics.vue'),
            children: [
              {
                path:"ComQuery",
                name:"ComQuery",
                component:()=>import('../views/Tab2/Content/BusinessSystem/QueryStatistics/ComQuery.vue')
              },
              {
                path:"MonthlyStatistics",
                name:"MonthlyStatistics",
                component:()=>import('../views/Tab2/Content/BusinessSystem/QueryStatistics/MonthlyStatistics.vue')
              },
              {
                path:"ReportQuery",
                name:"ReportQuery",
                component:()=>import('../views/Tab2/Content/BusinessSystem/QueryStatistics/ReportQuery.vue')
              },
            ]
          },
        ]
      },
      {
        path: "/Tab3Content",
        name: "Tab3Content",
        component: ()=> import('../views/Tab3/Content/Tab3Content.vue'),
        children: [
          {
            path: "TestingApplication",
            name: "Tab3/TestingApplication",
            component: () => import('../views/Tab3/Content/SampleManage/TestingApplication.vue'),
          },
          {
            path: "SampleInformation",
            name: "Tab3/SampleInformation",
            component: () => import('../views/Tab3/Content/SampleManage/SampleInformation.vue'),
          },
          {
            path: "NewSampleInformation",
            name: "Tab3/NewSampleInformation",
            component: () => import('../views/Tab3/Content/SampleManage/NewSampleInformation.vue'),
          },
          {
            path: "ChangeSampleInformation",
            name: "Tab3/ChangeSampleInformation",
            component: () => import('../views/Tab3/Content/SampleManage/ChangeSampleInformation.vue'),
          },
          {
            path: "ReportPackageRecord",
            name: "Tab3/ReportPackageRecord",
            component: () => import('../views/Tab3/Content/SampleManage/ReportPackageRecord.vue'),
          },
          {
            path: "NewReportPackageRecord",
            name: "Tab3/NewReportPackageRecord",
            component: () => import('../views/Tab3/Content/SampleManage/NewReportPackageRecord.vue'),
          },
          {
            path: "ReturningSamples",
            name: "Tab3/ReturningSamples",
            component: () => import('../views/Tab3/Content/ExpressManage/ReturningSamples.vue'),
          },
          {
            path: "ReturningSamplesRecord",
            name: "Tab3/ReturningSamplesRecord",
            component: () => import('../views/Tab3/Content/ExpressManage/ReturningSamplesRecord.vue'),
          },
          {
            path: "NewReturningSamplesRecord",
            name: "Tab3/NewReturningSamplesRecord",
            component: () => import('../views/Tab3/Content/ExpressManage/NewReturningSamplesRecord.vue'),
          },
          {
            path: "ReturnSampleInfo",
            name: "Tab3/ReturnSampleInfo",
            component: () => import('../views/Tab3/Content/ExpressManage/ReturnSampleInfo.vue'),
          },
          {
            path: "NewReturnSampleInfo",
            name: "Tab3/NewReturnSampleInfo",
            component: () => import('../views/Tab3/Content/ExpressManage/NewReturnSampleInfo.vue'),
          },
          {
            path: "ExpressManagement",
            name: "Tab3/ExpressManagement",
            component: () => import('../views/Tab3/Content/ExpressManage/ExpressManagement.vue'),
          },
          {
            path: "CompoundQuery",
            name: "Tab3/CompoundQuery",
            component: () => import('../views/Tab3/Content/QueryStatistics/CompoundQuery.vue'),
          },
          {
            path: "ReportQuery",
            name: "Tab3/ReportQuery",
            component: () => import('../views/Tab3/Content/QueryStatistics/ReportQuery.vue'),
          },
          {
            path: "SampleBoxApplication",
            name: "Tab3/SampleBoxApplication",
            component: () => import('../views/Tab3/Content/SampleBoxManage/SampleBoxApplication.vue'),
          },
          {
            path: "SampleBoxRecord",
            name: "Tab3/SampleBoxRecord",
            component: () => import('../views/Tab3/Content/SampleBoxManage/SampleBoxRecord.vue'),
          },
          {
            path: "BarcodeDatabase",
            name: "Tab3/BarcodeDatabase",
            component: () => import('../views/Tab3/Content/SampleBoxManage/BarcodeDatabase.vue'),
          },
          {
            path: "BasicInformation",
            name: "Tab3/BasicInformation",
            component: () => import('../views/Tab3/Content/InformationManage/BasicInformation.vue'),
          },
          {
            path: "User",
            name: "Tab3/User",
            component: () => import('../views/Tab3/Content/InformationManage/User.vue'),
          },
          {
            path: "AddUser",
            name: "Tab3/AddUser",
            component: () => import('../views/Tab3/Content/InformationManage/AddUser.vue'),
          },
          {
            path: "RightsManage",
            name: "Tab3/RightsManage",
            component: () => import('../views/Tab3/Content/InformationManage/RightsManage.vue'),
          },
          {
            path: "AddRole",
            name: "Tab3/AddRole",
            component: () => import('../views/Tab3/Content/InformationManage/AddRole.vue'),
          },
          {
            path: "SubmissionDepartment",
            name: "Tab3/SubmissionDepartment",
            component: () => import('../views/Tab3/Content/InformationManage/SubmissionDepartment.vue'),
          },
          {
            path: "AddDepartment",
            name: "Tab3/AddDepartment",
            component: () => import('../views/Tab3/Content/InformationManage/AddDepartment.vue'),
          },
          {
            path: "SubmissionPhysicians",
            name: "Tab3/SubmissionPhysicians",
            component: () => import('../views/Tab3/Content/InformationManage/SubmissionPhysicians.vue'),
          },
          {
            path: "AddPhysician",
            name: "Tab3/AddPhysician",
            component: () => import('../views/Tab3/Content/InformationManage/AddPhysician.vue'),
          },
        ]
      },
    ]
  }
]
//
// //��̬·��
// export  const constantRoutes = [
//     AddPhysician,
// ]
//
// //��̬·��
// export  const asyncRoutes = [
//     SubmissionPhysicians,
// ]
//
// const createRouter = () =>
//     new Router({
//       scrollBehavior: () =>({y:0}),
//       routes: [...constantRoutes]
//     })
// //�������еĶ�̬·�ɱ�(δ����ɸѡ)
// // 02 ��·���������������ж�̬·��
// import router, { asyncRoutes } from './router'
// import store from '@/store/index'
// // import { Message } from 'element-ui'
// // ������
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
// // import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
//
// // NProgress.configure({ showSpinner: false }) // NProgress Configuration
//
// // const whiteList = ['/login'] // no redirect whitelist
//
// // ��ת·�ɱ���
// router.beforeEach((to, from, next) => {
//   document.title = getPageTitle(to.meta.title)
//   next()
// })
//
// const whiteList = ['/404', '/login']
// router.beforeEach(async(to, from, next) => {
//   const token = store.state.user.token
//   console.log(to)
//   if (token) {
//     if (to.path === '/login') {
//       next('/')
//     } else {
//       if (!store.state.is_login) {
//         // ���û���û�id ��ʱ����ȥ����Ⱦ����
//         const menu = await store.dispatch('user/getUserInfo')
//         // 10�õ����Է��ʵ�ҳ��
//         console.log('�û����Է��ʵ�ҳ��', menu)
//         console.log('һ���е�ҳ��', asyncRoutes)
//         // 11 ����·��
//         const filterRoutes = asyncRoutes.filter(route => {
//           const name = route.children[0].name
//           return menu.includes(name)
//         })
//
//         // ���ˢ��404��ʾ404ҳ��
//         filterRoutes.push(
//           // 404 page must be placed at the end !!!
//           { path: '*', redirect: '/404', hidden: true }
//         )
//         // 03 ��̬����·��  ��������Ѿ�û��·���� ������Ȼ����ֱ�ӷ���
//         // router.addRoutes(asyncRoutes)
//
//         // 06 ����vuex �Ѷ�̬·�ɷŵ�vuex��
//         // store.commit('menu/setMenuList', asyncRoutes)
//         // 11 �ѹ��˺��·�����ӵ���̬����  ������ת·��
//         router.addRoutes(filterRoutes)
//         // 13 ������ʾ�˵���
//         store.commit('menu/setMenuList', filterRoutes)
//
//         // ���ˢ�³��ֵİ���bug
//         next({
//           ...to, // next({ ...to })��Ŀ��,�Ǳ�֤·�����������ٽ���ҳ�� (��������Ϊ�ؽ�һ��)
//           replace: true // �ؽ�һ��, �������ظ���ʷ
//         })
//       } else {
//         next()
//       }
//     }
//   } else {
//     // ��Ϊ�Ǻ�̨����ϵͳ ���ܷ��ʱ��ҳ��
//     whiteList.includes(to.path) ? next() : next('/login')
//   }
//   // ��������ʼ
//   NProgress.start()
// })
//
// router.afterEach(() => {
//   // finish progress bar
// //   ��ȥҳ��֮�����������
//   NProgress.done()
// })
//
// routes() {
//   // �õ�����һ�������İ����˾�̬·�ɺͶ�̬·�ɵ����ݽṹ
//   // return this.$router.options.routes  ������·�ɸ�Ϊ��vuex�е�����·��
//   return this.$store.state.menu.menuList
// }

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to,from,next)=> {
    // next()
    // console.log(sessionStorage)
    // const isLogin = sessionStorage.getItem('is_login')

    // ����������
    NProgress.start()
    // NProgress.set(0.3)
    // NProgress.speed = 10
    //
    // window.setTimeout(() => {
    //   console.log('500ms��ִ�еķ���');
    // }, 500);

    // console.log(store.state)
    const isLogin = store.state.is_login
    if (to.path === "/login" || to.path === "/") {
      if (isLogin === "true") {
        next("/home");
      } else {
        next();
      }
    } else if(to.path === "/preview") {
        next();
    } else {
        if (isLogin === "true") {
          next();
        } else {
          next("/login");
        }
    }

    // // ����������
    // NProgress.done()
})

router.afterEach((to, from) => {
	NProgress.done()
})
export default router